import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, Chip } from "@mui/material";

const MedCodesGrid = ({ rows, onDelete, onAccept, onReject, editable }) => {
  const columns = [
    { field: "code", headerName: "Code", width: 120 },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      renderCell: (p) => <span dangerouslySetInnerHTML={{ __html: p.value }} />,
    },
    {
      field: "status",
      headerName: "Status",
      width: 120,
      renderCell: (p) =>
        p.value === "Suggested" ? (
          <Chip label="Suggested" color="warning" size="small" />
        ) : (
          <Chip label="Saved" color="success" size="small" />
        ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      renderCell: (p) => {
        if (!editable) return null;

        if (p.row.status === "Suggested") {
          return (
            <>
              <Button
                size="small"
                color="success"
                onClick={() => onAccept(p.row)}
              >
                Accept
              </Button>
              <Button
                size="small"
                color="error"
                onClick={() => onReject(p.row)}
              >
                Reject
              </Button>
            </>
          );
        }

        return (
          <Button size="small" color="error" onClick={() => onDelete(p.row)}>
            Delete
          </Button>
        );
      },
    },
  ];

  return (
    <Box sx={{ height: 350, width: "100%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        hideFooter
        getRowId={(row) => row?.id}
      />
    </Box>
  );
};

export default MedCodesGrid;
